
import React from "react"
import { FC, ChangeEventHandler } from "react";
import CustomLabel from "./CustomLabel";
import { Select } from "antd";
import { cn } from "../helper/classNames";
import ErrorContainer from "../common/ErrorContainer";
import { labels } from "../resources";

export interface ISelectOption {
  value: string | number;
  label: string;
}

export interface ICustomSelect {
  name?: string;
  label?: string;
  required?: boolean;
  value?: any;
  options: ISelectOption[];
  onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
  className?: string;
  disabled?: boolean;
  touched?: boolean | string | undefined;
  error?: string | undefined| string[];
  mode?: "multiple" | "tags";
  notFoundContent?: string;
  popupClassName?: string;
  placeholder?: string;
  size?: "small" | "middle" | "large";
  allowClear?: boolean;
  lableClassName?: string;
}

const CustomSelect: FC<ICustomSelect> = ({
  label,
  value,
  options,
  onChange,
  className,
  disabled,
  touched,
  error,
  required,
  mode,
  notFoundContent,
  placeholder = labels.all,
  size = "middle",
  allowClear = true,
  lableClassName = ""
}) => {
  const handleFilterOptions = (input: string, option: string | undefined) => {
    return (option ?? "").toLowerCase().includes(input.toLowerCase());
  };

  return (
    <>
      <CustomLabel
        label={label}
        required={required}
        className={lableClassName}
      />
      <Select
        className={cn("w-full", "min-w-[135px]", "max-w-[350px]", className)}
        onChange={onChange}
        disabled={disabled}
        options={options}
        value={value || undefined}
        notFoundContent={notFoundContent}
        showSearch
        filterOption={(input, option) => handleFilterOptions(input, option?.label as string)}
        placeholder={placeholder}
        mode={mode}
        size={size}
        allowClear={allowClear}
      />
      <ErrorContainer
        touched={touched}
        error={error}
      />
    </>
  );
};

export default CustomSelect;
